import React from "react";
import { initials, colorFromName } from "@/lib/format";

export default function Avatar({ name, size = 40, className = "" }) {
  const bg = colorFromName(name);
  return (
    <div
      className={`shrink-0 rounded-full text-white font-semibold flex items-center justify-center ${className}`}
      style={{ width: size, height: size, background: bg, fontSize: Math.max(11, size * 0.36) }}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
